import React from 'react';
import './Analysts.css';

// Import the new image
import teamImage from '../../assets/images/analyst-team.jpg';

const Analysts = () => {
  return (
    <section className="analysts-section">
      <div className="analysts-container">
        {/* --- Left Column: Text Content --- */}
        <div className="analysts-text-col">
          <div className="section-header">
            <h2>Analysts you can trust</h2>
          </div>
          <p>
            Behind every price is a trained expert who understands the market and the responsibility. CRISHI's assessments are led by a team of SEBI-certified, NISM-trained analysts.
          </p>
          <p>
            Our team follows a strict code of ethics and a structured approach to ensure every number is accurate, unbiased, and meaningful.
          </p>
        </div>

        {/* --- Right Column: Image --- */}
        <div className="analysts-image-col">
          <img src={teamImage} alt="CRISHI analyst team at work" />
        </div>
      </div>
    </section>
  );
};

export default Analysts;